import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { FilterService } from 'src/app/services/filter.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AliquotTax } from '../../../model/aliquot-tax';
import { MedicalFeeTaxAmount } from '../../../model/medical-fee/medical-fee-tax-amount';
import { TaxType } from '../../../model/tax-type';

@Component({
  selector: 'app-medical-fee-tax-amount-dialog',
  templateUrl: './medical-fee-tax-amount-dialog.component.html',
  styleUrls: ['./medical-fee-tax-amount-dialog.component.css']
})
export class MedicalFeeTaxAmountDialogComponent implements OnInit {

  form: FormGroup;
  loading: boolean;
  aliquotTaxs: AliquotTax[] = [];
  aliquotTaxsFiltered: AliquotTax[] = [];
  taxTypes: TaxType[] = [];

  constructor(  public dialogRef: MatDialogRef<MedicalFeeTaxAmountDialogComponent>,
                private notificationToastService: NotificationToastService,
                private filterService: FilterService,
                private formBuilder: FormBuilder,
                @Inject(MAT_DIALOG_DATA) public data: any ) {

    this.form = this.formBuilder.group({
      AliquotTax: ['', Validators.required],
      AmountBase: ['', Validators.required],
      TaxType: ['', Validators.required],
      Description: [''],
    });

    this.form.controls.TaxType.valueChanges
        .subscribe( ( value: TaxType ) => {
      this.aliquotTaxsFiltered = [];
      if ( value ) {
        this.aliquotTaxsFiltered = this.aliquotTaxs.filter(a => a.TaxId === value.Id);
      }
    });

  }

  get f() { return this.form.controls; }

  async ngOnInit() {

    this.taxTypes = await this.filterService.getTaxTypes();
    this.aliquotTaxs = await this.filterService.getAliquotsTax();

  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  save() {
    try {
      if (!this.form.invalid) {
          this.dialogRef.close(<MedicalFeeTaxAmount>this.form.getRawValue());
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Retenciones');
    }
  }
}
